import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import Access_ControlConstants from "./../Constants/Access_ControlConstants";

class Access_ControlActions {
  async login(user, forPasswordValidationOnly) {
    httpRequest(
      config.webServiceURL + "/token",
      "POST",
      JSON.stringify({
        username: user.username,
        password: user.password,
        language: user.language,
        OrganisationId: user.OrganisationId,
        IsPublicWebsite: user.IsPublicWebsite,
      }),
      (res, message) => {
        if (res !== "Error") {
          if (forPasswordValidationOnly) {
            dispatcher.dispatch({
              type: Access_ControlConstants.PASSWORD_VALIDATION_SUCCESS,
              result: res,
            });
          } else {
            dispatcher.dispatch({
              type: Access_ControlConstants.LOGIN_SUCCESS,
              result: res,
            });
          }
        } else {
          if (forPasswordValidationOnly) {
            dispatcher.dispatch({
              type: Access_ControlConstants.PASSWORD_VALIDATION_FAILURE,
              result: message,
            });
          } else {
            dispatcher.dispatch({
              type: Access_ControlConstants.LOGIN_FAILURE,
              result: message,
            });
          }
        }
      }
    );
  }

  logout() {
    httpRequest(
      config.webServiceURL + "/token/Logout",
      "Delete",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.LOGOUT_SUCCESS,
            result: res,
          });
        }
      }
    );
  }

  forgetPassword(passwordForget) {
    httpRequest(
      config.webServiceURL + "/token/ForgotPassword",
      "PUT",
      JSON.stringify({
        Email: passwordForget.Email,
        Language: passwordForget.Language,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.FORGET_PASSWORD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.FORGET_PASSWORD_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  changePassword(passwordChange) {
    httpRequest(
      config.webServiceURL + "/UserManagement/ChangePassword",
      "PUT",
      JSON.stringify({
        ID: passwordChange.ID,
        OldPassword: passwordChange.OldPassword,
        NewPassword: passwordChange.NewPassword,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.CHANGE_PASSWORD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.CHANGE_PASSWORD_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getAnlages(token, parentID) {
    httpRequest(
      config.webServiceURL + "/Anlage/GetAnlages/" + token + "/" + parentID,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_EQI_LIST_TOKEN_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_EQI_LIST_TOKEN_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  gatAnlageChildren(parentId) {
    httpRequest(
      config.webServiceURL + "/Anlage/GetAnlageChildren/" + parentId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_ANLAGE_CHILDREN_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_ANLAGE_CHILDREN_FAILURE,
            result: res,
          });
        }
      }
    );
  }

  addAnlageChild(parentId, childId) {
    httpRequest(
      config.webServiceURL +
        "/Anlage/AddAnlageChild/" +
        parentId +
        "/" +
        childId,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.ADD_ANLAGE_CHILD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.ADD_ANLAGE_CHILD_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteAnlageChild(parentId, childId) {
    httpRequest(
      config.webServiceURL +
        "/Anlage/DeleteAnlageChild/" +
        parentId +
        "/" +
        childId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.DELETE_ANLAGE_CHILD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.DELETE_ANLAGE_CHILD_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getAnlageAttributeBulkUpdateForm(equipId) {
    httpRequest(
      config.webServiceURL +
        "/Anlage/GetAnlageAttributeBulkUpdateForm/" +
        equipId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  saveUpdateAnlageBulkDetails(attributeData) {
    httpRequest(
      config.webServiceURL + "/Anlage/SaveUpdateBuldAnlageAttribute",
      "POST",
      JSON.stringify({
        ...attributeData,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  bulkDeleteAnlageDetails(attributeData) {
    httpRequest(
      config.webServiceURL + "/Anlage/BulkDeleteAnlage",
      "POST",
      JSON.stringify({
        ...attributeData,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  GetAnlageLastInspections(anlageId) {
    httpRequest(
      config.webServiceURL + "/Anlage/GetAnlageLastInspections/" + anlageId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_FAILURE,
            result: res,
          });
        }
      }
    );
  }

  loginPublicAccess(user) {
    httpRequest(
      config.webServiceURL + "/token/GetMobileToken",
      "POST",
      JSON.stringify({
        ...user,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.LOGIN_PUBLIC_ACCESS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.LOGIN_PUBLIC_ACCESS_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  GetLocalizationMessages(language) {
    httpRequest(
      config.webServiceURL + "/token/GetLocalizationMessages/" + language,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_LOCALIZATION_MESSAGE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.GET_LOCALIZATION_MESSAGE_FAILURE,
            result: res,
          });
        }
      }
    );
  }

  bulkUpdateAnlageStatus(_Data) {
    httpRequest(
      config.webServiceURL + "/Anlage/BulkUpdateEquipmentStatus",
      "POST",
      JSON.stringify({
        ..._Data,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new Access_ControlActions();
